import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import token from 'styled-token';
import { withIcon } from '../Icon';
export var StyledZillowBanner = /*#__PURE__*/styled.polygon.withConfig({
  displayName: "StyledZillowBanner",
  componentId: "c11n-8-111-1__sc-iyto7b-0"
})(["fill:", ";"], token('colors.brandSecondary'));
export var BestOfZillowSVG = function BestOfZillowSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement(StyledZillowBanner, {
    points: "8.7 19.9 8.7 30 16 24.2 23.3 30 23.3 19.9 8.7 19.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,6.3a.1.1,0,0,1,.1.1A9.3,9.3,0,0,1,20,7.9h0a27,27,0,0,0-4.5,4.4h0a43.5,43.5,0,0,1,7.8-2.3V7.7L16,2,8.7,7.7v2.6A55.5,55.5,0,0,1,18.6,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7,16.2h-.2l-1.4-1.7h0a26.9,26.9,0,0,1,4.6-4.9h0a60.1,60.1,0,0,0-7,3.1V18H23.3V12.7A48.5,48.5,0,0,0,12.7,16.2Z"
  })));
};
BestOfZillowSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BestOfZillowSVG);